import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
import cloneDeep from 'lodash/cloneDeep';
import { calculateTextExprValue } from '@/common/util/util';
import isPlainObject from 'lodash/isPlainObject';
import { handleRequestParams } from '@/common/util/request';
export const config = {
    value: 'setFilterValue',
    position: ALL_BUTTON_POSITION_LIST,
    action: (config) => {
        const { buttonConfig, urlParamsDataSource, state, _context } = config || {};
        const { options } = buttonConfig || {};
        const { formValues, _bindFilter, handleFilterType, allFilterValues } = options || {};
        if (_bindFilter) {
            const formNode = _context?.$(_bindFilter);
            const formInstance = formNode?.getFormInstance?.();
            const oldFormValue = cloneDeep(formInstance?.values);
            if (formInstance) {
                if (handleFilterType === 'clearFilterValue') {
                    formInstance.setValues?.({}, 'overwrite');
                }
                else if (handleFilterType === 'setAllFilterValue') {
                    const newFormValue = calculateTextExprValue(allFilterValues, {
                        urlParamsDataSource,
                        recordDataSource: oldFormValue,
                        state,
                    });
                    if (isPlainObject(newFormValue)) {
                        formInstance.setValues?.(newFormValue, 'overwrite');
                    }
                }
                else {
                    let newFormValue;
                    if (Array.isArray(formValues)) {
                        if (formValues.length > 0) {
                            const temp = handleRequestParams(formValues, {
                                urlParamsDataSource,
                                recordDataSource: oldFormValue || {},
                                state,
                            });
                            if (isPlainObject(temp)) {
                                newFormValue = temp;
                            }
                        }
                    }
                    formInstance.setValues?.(newFormValue);
                }
            }
        }
        return Promise.resolve();
    },
};
